import React, { useState, useEffect, useMemo } from 'react';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { renderToStaticMarkup } from 'react-dom/server';
import './Resources.css';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import Spinner from '../Spinner/Spinner';
import { FaUnlockAlt } from "react-icons/fa";
import { Form, Collapse } from 'react-bootstrap';
import InnerHTML from 'dangerously-set-html-content';
import { handleException } from "../../app/util/util";
import { addAccessibilityToAudioPlayer } from './utils';
import loaderColors1 from '../Spinner/loaderColors1.gif';
export default function Resources(props) {
    const userVO = JSON.parse(localStorage.getItem('userVO'));
    const history = props.history, isbn = props.match.params.isbn;
    const bookVOInfo = JSON.parse(localStorage.getItem('bookVO'));
    const keepMeLogIn = localStorage.getItem('keepLoggedIn') ? "true" : "false";
    const [resNodesVOList, setResNodesVOList] = useState([]);
    const [isResPageLoading, setIsResPageLoading] = useState(true);
    const [bookVO, setBookVO] = useState(JSON.parse(localStorage.getItem('bookVO')));
    const [currTabContent, setCurrTabContent] = useState(({
        currResNodeTitle: "", currResNodeInstrFlag: "", currResNodeId: "",
        currResNodeHTMLData: "", currResNodeConDisp: false
    }));
    function fetchResPageContent() {
        var reqData = {
            "userVO": {
                "userId": userVO.userId,
                "userRole": userVO.userRole,
                "userRoleId": userVO.userRoleId,
                "userActivityVO": {
                    "lastReadBookId": "",
                    "lastReadPageNum": "",
                    "lastReadChapterId": "",
                    "lastReadSectionId": "",
                    "lastViewedOutlineId": "",
                    "lastReadParagraphId": "",
                    "lastReadSubSectionId": "",
                    "lastActivityCode": "BOOKSHELF",
                    "pageNavigatingFrom": "EReader",
                    "pageNavigatingTo": "Bookshelf",
                },
                "sessionVO": {
                    "appType": "web",
                    "deviceMacId": "",
                    "keepMeLoggedInFlag": keepMeLogIn,
                    "deviceOS": localStorage.getItem('deviceOS'),
                    "deviceType": localStorage.getItem('deviceType'),
                    "browserName": localStorage.getItem('browserName'),
                    "sessionAuthenticationToken": userVO.sessionAuthenticationToken,
                }
            },
            resourceVO: { "resourceISBN": isbn }
        }
        const requestOptions = {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(reqData)
        };
        fetch(`${localStorage.getItem('ENV')}/manageResource/getResourceContentRV`, requestOptions)
            .then(response => response.json())
            .then(data => {
                if (data.status === "true") {
                    var resourceVO = data.resourceVO;
                    if (resourceVO !== undefined && resourceVO.validityStatus === "active") {
                        if (data.resourceNodeVOList !== undefined) {
                            var dataResNodeVO = Array.isArray(data.resourceNodeVOList) ? data.resourceNodeVOList : [data.resourceNodeVOList];
                            dataResNodeVO.map(resNode => {
                                if (resNode.resourceSubNodeVOList) {
                                    resNode.resourceSubNodeVOList = Array.isArray(resNode.resourceSubNodeVOList) ? resNode.resourceSubNodeVOList : [resNode.resourceSubNodeVOList];
                                }
                            });
                            var roleBasedResNodeVO = (userVO.userRole === "Student") ? (
                                dataResNodeVO.filter(resNode => (resNode.instructorFlag !== undefined && resNode.instructorFlag === "false"))
                            ) : dataResNodeVO;
                            var modifyDataResNodeVO = roleBasedResNodeVO.map(resNode => {
                                if (resNode.resourceSubNodeVOList) {
                                    resNode.resourceSubNodeVOList = resNode.resourceSubNodeVOList.map(resSubNode => {
                                        return { ...resSubNode, subNode_active_status: false }
                                    })
                                    return { ...resNode, node_expand_status: false, node_active_status: false }
                                } else {
                                    return { ...resNode, node_active_status: false }
                                }
                            });
                            var urlNodeId = history.location.hash.replace("#", ""),
                                urlNode = modifyDataResNodeVO.find(resNode => (resNode.nodeId === urlNodeId)),
                                currURLNode = urlNode !== undefined ? urlNode : modifyDataResNodeVO[0];
                            handleCurrResTabContent(currURLNode);
                            modifyDataResNodeVO.map(resNode => {
                                if (resNode.nodeId === currURLNode.nodeId) {
                                    resNode.node_active_status = !resNode.node_active_status;
                                }
                            });
                            setResNodesVOList(modifyDataResNodeVO);
                        }
                    } if (data.bookVO) {
                        setBookVO(data.bookVO);
                    }
                    setIsResPageLoading(false);
                } else if (data.wkErrorCode) {
                    handleException(data);
                }
            }).catch(error => {
                setIsResPageLoading(false);
                console.error("There has been a problem with your fetch operation:", error);
            });
    }
    function fetchPermaLinkResNode(permaUrl, permaNodeId) {
        var reqData = {
            "userVO": {
                "resLink": permaUrl,
                "userId": userVO.userId,
                "userRole": userVO.userRole,
                "userRoleId": userVO.userRoleId,
                "userAuthenticationWithBookAccessCodeFlag": "false",
                "userActivityVO": {
                    "lastReadBookId": "",
                    "lastReadPageNum": "",
                    "lastReadChapterId": "",
                    "lastReadSectionId": "",
                    "lastViewedOutlineId": "",
                    "lastReadParagraphId": "",
                    "lastReadSubSectionId": "",
                    "lastActivityCode": "BOOKSHELF",
                    "pageNavigatingFrom": "EReader",
                    "pageNavigatingTo": "Bookshelf",
                },
                "sessionVO": {
                    "appType": "web",
                    "deviceMacId": "",
                    "keepMeLoggedInFlag": keepMeLogIn,
                    "deviceOS": localStorage.getItem('deviceOS'),
                    "deviceType": localStorage.getItem('deviceType'),
                    "browserName": localStorage.getItem('browserName'),
                    "sessionAuthenticationToken": userVO.sessionAuthenticationToken,
                }
            }
        }
        const requestOptions = {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(reqData)
        };
        fetch(`${localStorage.getItem('ENV')}/manageResource/getPublishedResourceNodeDetails`, requestOptions)
            .then(response => response.json())
            .then(data => {
                if (data && data.status === "true") {
                    var nodeId = "", instructorFlag = "", bISBN = "";
                    if (data.resourceVO) {
                        var resourceVO = data.resourceVO;
                        resourceVO = Array.isArray(resourceVO) ? resourceVO : [resourceVO];
                        bISBN = resourceVO[0].resourceISBN;
                    }
                    if (data.resourceNodeVOList) {
                        var resourceNodeVOList = data.resourceNodeVOList;
                        resourceNodeVOList = Array.isArray(resourceNodeVOList) ? resourceNodeVOList : [resourceNodeVOList];
                        nodeId = resourceNodeVOList[0].nodeId;
                        instructorFlag = resourceNodeVOList[0].instructorFlag;
                    }
                    if (instructorFlag === "true" && userVO.userRole === "Student") {
                        window.location = `${localStorage.getItem("BASE_URL")}ErrorPage404.html`;
                    } else if (bISBN !== null && bISBN !== "") {
                        localStorage.setItem("permaOrigin", "false");
                        if (nodeId !== null && nodeId !== "")
                            handlePermaTabExpandSubTabActive(permaNodeId, nodeId);
                    }
                } else if (data.wkErrorCode) {
                    handleException(data);
                }
            }).catch(error => {
                console.error("There has been a problem with your fetch operation:", error);
            });
    }
    useEffect(() => {
        fetchResPageContent();
        document.title = `${bookVOInfo && bookVOInfo.bookTitle !== undefined ? bookVOInfo.bookTitle : ""} | Resources | Aspen Publishing `;
    }, []);
    const handleCurrResTabContent = (currNode, currNodeType) => {
        if (currNode !== undefined) {
            if (currNodeType === undefined) {
                fetch(currNode.htmlS3URL).then(response => response.text()).then(currNodeData => {
                    setCurrTabContent({
                        currResNodeTitle: currNode.nodeTitle, currResNodeInstrFlag: currNode.instructorFlag,
                        currResNodeId: currNode.nodeId, currResNodeHTMLData: currNodeData, currResNodeConDisp: true
                    })
                }).catch(error => {
                    console.error("There has been a problem with your fetch operation:", error);
                });
            } else {
                fetch(currNode.htmlS3URL).then(response => response.text()).then(currSubNodeData => {
                    setCurrTabContent({
                        currResNodeTitle: currNode.subNodeTitle, currResNodeInstrFlag: currNode.instructorFlag,
                        currResNodeHTMLData: currSubNodeData, currResNodeConDisp: true
                    })
                }).catch(error => {
                    console.error("There has been a problem with your fetch operation:", error);
                });
            }
        }
    }
    const handleCurrResTabActive = (currResTabType, currResTabActId) => {
        if (currResTabType === "resTab") {
            var currResNode = resNodesVOList.find(resNode => resNode.nodeId === currResTabActId);
            if (currResNode !== undefined) {
                handleCurrResTabContent(currResNode);
                window.history.replaceState(null, null, `/${localStorage.getItem("reactNodeName") + history.location.pathname}#${currResTabActId}`)
            }
            const newCurrResTabActive = resNodesVOList.map(resNode => {
                if (resNode.resourceSubNodeVOList) {
                    resNode.resourceSubNodeVOList = resNode.resourceSubNodeVOList.map(resSubNode => {
                        return { ...resSubNode, subNode_active_status: false }
                    })
                }
                if (resNode.nodeId === currResTabActId) {
                    return { ...resNode, node_active_status: true }
                }
                return { ...resNode, node_active_status: false }
            });
            setResNodesVOList(newCurrResTabActive);
        } else {
            var currResTabId = currResTabActId.split(" "), currNodeId = currResTabId[0], currSubNodeId = currResTabId[1];
            var currResNode = resNodesVOList.find(resNode => resNode.nodeId === currNodeId),
                currResSubNode = currResNode.resourceSubNodeVOList.find(resSubNode => resSubNode.subNodeId === currSubNodeId);
            if (currResSubNode !== undefined) {
                handleCurrResTabContent(currResSubNode, "currSubNode");
                window.history.replaceState(null, null, `/${localStorage.getItem("reactNodeName") + history.location.pathname}#${currSubNodeId}`);
            }
            const newCurrResSubTabActive = resNodesVOList.map(resNode => {
                if (resNode.resourceSubNodeVOList) {
                    resNode.resourceSubNodeVOList = resNode.resourceSubNodeVOList.map(resSubNode => {
                        if (resSubNode.subNodeId === currSubNodeId) {
                            return { ...resSubNode, subNode_active_status: true }
                        }
                        return { ...resSubNode, subNode_active_status: false }
                    })
                }
                return { ...resNode, node_active_status: false }
            });
            setResNodesVOList(newCurrResSubTabActive);
        }
    }
    const handleCurrResTabExpand = (currResTabExpId) => {
        const newCurrResTabExpand = resNodesVOList.map(resNode => {
            if (resNode.nodeId === currResTabExpId) {
                return { ...resNode, node_expand_status: !resNode.node_expand_status }
            }
            return resNode;
        });
        setResNodesVOList(newCurrResTabExpand);
    }
    const handlePermaTabExpandSubTabActive = (clickPermaNodeId, clickPermaSubNodeId) => {
        if (clickPermaNodeId && clickPermaSubNodeId) {
            const newCurrResTabExpand = resNodesVOList.map(resNode => {
                if (resNode.nodeId === clickPermaNodeId) {
                    return { ...resNode, node_expand_status: true }
                }
                return resNode;
            });
            var currResNode = newCurrResTabExpand.find(resNode => resNode.nodeId === clickPermaNodeId),
                currResSubNode = currResNode.resourceSubNodeVOList.find(resSubNode => resSubNode.subNodeId === clickPermaSubNodeId);
            if (currResSubNode !== undefined) {
                handleCurrResTabContent(currResSubNode, "currSubNode");
                window.history.replaceState(null, null, `/${localStorage.getItem("reactNodeName") + history.location.pathname}#${clickPermaSubNodeId}`);
            }
            const newCurrResSubTabActive = newCurrResTabExpand.map(resNode => {
                if (resNode.resourceSubNodeVOList) {
                    resNode.resourceSubNodeVOList = resNode.resourceSubNodeVOList.map(resSubNode => {
                        if (resSubNode.subNodeId === clickPermaSubNodeId) {
                            return { ...resSubNode, subNode_active_status: true }
                        }
                        return { ...resSubNode, subNode_active_status: false }
                    })
                }
                return { ...resNode, node_active_status: false }
            });
            setResNodesVOList(newCurrResSubTabActive);
        }
    }
    const onResourceContainerClick = (e, permaLinkNodeId) => {
        if (e.target.getAttribute("fileid") !== null) {
            document.getElementById("userIdDownload").value = userVO.userId;
            document.getElementById("userRoleDownload").value = userVO.userRole;
            document.getElementById("userRoleIdDownload").value = userVO.userRoleId;
            document.getElementById("appTypeDownload").value = "web";
            document.getElementById("deviceTypeDownload").value = localStorage.getItem('deviceType');
            document.getElementById("deviceOSDownload").value = localStorage.getItem('deviceOS');
            document.getElementById("fileIdDownload").value = e.target.getAttribute("fileid");
            document.getElementById("sessionAuthenticationTokenDownload").value = userVO.sessionAuthenticationToken;
            document.getElementById('downloadFormResource').action = localStorage.getItem('ENV') + "/manageResource/downloadResourceDocumentForApplication";
            document.getElementById('downloadFormResource').submit();
        } else if (e.target.getAttribute("href") && e.target.getAttribute("href").split('plink')[1]) {
            e.preventDefault();
            var permaLinkUrl = e.target.getAttribute("href").split('plink')[1];
            permaLinkNodeId && fetchPermaLinkResNode(permaLinkUrl, permaLinkNodeId);
        }
    }
    const handleLeftResourceContent = (e, nodeId) => {
        if (e.key === 'Enter') {
            handleCurrResTabActive('resTab', nodeId);
        }
    }
    const handleOnResourceContainerClick = (e, currResNodeId) => {
        if (e.key === 'Enter') {
            onResourceContainerClick(e, currResNodeId);
        }
    }
    const handleExpandResource = (e, nodeId) => {
        if (e.key === 'Enter') {
            handleCurrResTabExpand(nodeId);
        }
    }
    const handleCurResActive = (e, currResTabType, currResTabActId) => {
        if (e.key === 'Enter') {
            handleCurrResTabActive(currResTabType, currResTabActId)
        }
    }
    const externalIconHtml = useMemo(() => renderToStaticMarkup(<FontAwesomeIcon icon={faExternalLinkAlt} style={{ color: "#3333FF", fontSize: "12px", marginLeft: "4px" }} />), []);
    const transformedResNodeHTMLData = useMemo(() => {
        let data = currTabContent.currResNodeHTMLData;
        if (
            currTabContent.currResNodeHTMLData.indexOf("cdn.commoninja.com") !== -1 &&
            currTabContent.currResNodeHTMLData.indexOf('class="commonninja_component') !== -1 &&
            currTabContent.currResNodeHTMLData.indexOf("pid") !== -1
        ) {
            addAccessibilityToAudioPlayer();
        }
        if (currTabContent.currResNodeHTMLData.indexOf("<a") !== -1) {
            const htmlDataArray = data.split("<a");
            const internalUrlRegex = new RegExp(' href="(.*)casebookconnect.com(.*)"(.*)>(.*)</a>(.*)');
            data = htmlDataArray.map((el, i) => i === 0 ? el : internalUrlRegex.test(el) ? `<a tabindex="0" class="linkContent"${el}` : `<a tabindex="0" class="linkContent"${el.split("</a>")[0]}${externalIconHtml}</a>${el.split("</a>")[1]}`).join("");
        }
        if (currTabContent.currResNodeHTMLData.indexOf("<label") !== -1) {
            const htmlDataArray = data.split("<label");
            const downloadRegex = new RegExp(' onclick="downloadDocResource\\(event\\);"(.*)fileid="[0-9]+"(.*)>(.*)</label>(.*)');
            data = htmlDataArray.map((el, i) => i === 0 ? el : downloadRegex.test(el) ? `<label role="button" tabindex="0"${el}` : `<label tabindex="0"${el}`).join("");
        }
        return data;
    }, [currTabContent.currResNodeHTMLData, externalIconHtml]);
    return (
        <React.Fragment>
            <Header userVO={userVO} bookVO={bookVO} pageName="resource"></Header>
            <Spinner
                loading={isResPageLoading}
                imageSrc={loaderColors1}
                overlayBackground="rgba(0,0,0,0.5)"
                label="Loading resources"
            />
            {
                isResPageLoading === false &&
                <>
                    <div>
                        <Form method="POST" id="downloadFormResource">
                            <input type="hidden" id="userIdDownload" name="userId" />
                            <input type="hidden" id="userRoleDownload" name="userRole" />
                            <input type="hidden" id="userRoleIdDownload" name="userRoleId" />
                            <input type="hidden" id="appTypeDownload" name="appType" />
                            <input type="hidden" id="deviceTypeDownload" name="deviceType" />
                            <input type="hidden" id="deviceOSDownload" name="deviceOS" />
                            <input type="hidden" id="sessionAuthenticationTokenDownload" name="sessionAuthenticationToken" />
                            <input type="hidden" id="fileIdDownload" name="fileId" />
                        </Form>
                    </div>
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 resourceTab_rt">
                        <div id="leftToggleBlockId" className="col-xl-5 col-lg-5 col-md-5 col-sm-5 col-xs-12 display-inline-block">
                            {
                                resNodesVOList !== undefined ?
                                    resNodesVOList.map(resNode => {
                                        return (
                                            <>
                                                {
                                                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding mBottomTen">
                                                        <div className={resNode.node_active_status === true ? "leftResourceBtn_rt active row" : "leftResourceBtn_rt row"}>
                                                            <div data-testid={`resNode_${resNode.nodeId}`} className="display-inline-block leftResourceBtnCont col" id={resNode.nodeId}
                                                                onClick={() => handleCurrResTabActive('resTab', resNode.nodeId)} tabIndex="0" onKeyDown={(e) => handleLeftResourceContent(e, resNode.nodeId)}>{resNode.nodeName}
                                                                {
                                                                    (resNode.instructorFlag !== undefined && resNode.instructorFlag === "true") ?
                                                                        <FaUnlockAlt className={resNode.node_active_status === true ? "FaUnlockAltBtn  mLeftFive" : "FaUnlockAltBtnSuccess mLeftFive"}></FaUnlockAlt>
                                                                        : null
                                                                }
                                                            </div>
                                                            {
                                                                resNode.resourceSubNodeVOList !== undefined ?
                                                                    <>
                                                                        <div className="display-inline-block expandText_rt">
                                                                            <div data-testid={`resSubNode_${resNode.nodeId}`} className={resNode.node_active_status === true ? "pull-right expandColorCode" : "pull-right collapseColorCode"}
                                                                                onClick={() => handleCurrResTabExpand(resNode.nodeId)} tabIndex="0" onKeyPress={(e) => handleExpandResource(e, resNode.nodeId)}
                                                                                aria-label={`${(resNode.node_expand_status === true ? 'Collapse' : 'Expand') + " " + resNode.nodeName}`}
                                                                                role="button" aria-expanded={resNode.node_expand_status}>
                                                                                {resNode.node_expand_status === true ? `Collapse` : `Expand`}
                                                                            </div>
                                                                        </div>
                                                                        {
                                                                            resNode.resourceSubNodeVOList.map(resSubNode => {
                                                                                return (
                                                                                    <>
                                                                                        <Collapse in={resNode.node_expand_status}>
                                                                                            <div style={{ "cursor": "pointer", width: '100%' }} className="expandedBlock_rt">
                                                                                                <div data-testid={`resSubTab_${resSubNode.subNodeId}`} style={{ "cursor": "pointer", width: '100%' }} id={resSubNode.subNodeId}
                                                                                                    className={resSubNode.subNode_active_status === true ? "expandedBtn_rt  leftResourceBtn_rt  active" : "expandedBtn_rt"}
                                                                                                    onClick={() => handleCurrResTabActive('resSubTab', (resSubNode.nodeId + " " + resSubNode.subNodeId))} tabIndex="0"
                                                                                                    onKeyDown={(e) => handleCurResActive(e, 'resSubTab', (resSubNode.nodeId + " " + resSubNode.subNodeId))}>{resSubNode.subNodeName}
                                                                                                    {
                                                                                                        (resSubNode.instructorFlag !== undefined && resSubNode.instructorFlag === "true") ?
                                                                                                            <FaUnlockAlt className={resSubNode.subNode_active_status === true ? "FaUnlockAltBtn mLeftFive" : "FaUnlockAltBtnSuccess mLeftFive"}></FaUnlockAlt>
                                                                                                            : null
                                                                                                    }
                                                                                                </div>
                                                                                            </div>
                                                                                        </Collapse>
                                                                                    </>
                                                                                )
                                                                            })
                                                                        }
                                                                    </>
                                                                    : null
                                                            }
                                                        </div>
                                                    </div>
                                                }
                                            </>
                                        )
                                    })
                                    : null
                            }
                        </div>
                        <div id="rightSideToggleBlockId" className="collapseBlock_rt col-xl-7 col-lg-7 col-md-7 col-sm-7 col-xs-12 display-inline-block mBottomTen">
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding">
                                <Collapse in={currTabContent.currResNodeConDisp}>
                                    <div className="">
                                        {
                                            currTabContent.currResNodeInstrFlag === "true" &&
                                            <div className="professorViewResource_rt mBottomTwnty">Only professors can view this page in Resources.</div>
                                        }
                                        <h4 id="resourceTitle" className="resourceTabHeader">{currTabContent.currResNodeTitle}</h4>
                                        {
                                            currTabContent.currResNodeHTMLData &&
                                            <div data-testid="content" className="resourceTabCont mBottomTwnty" onClick={(e) => onResourceContainerClick(e, currTabContent.currResNodeId)} tabIndex="0" onKeyDown={(e) => handleOnResourceContainerClick(e, currTabContent.currResNodeId)}>
                                                <InnerHTML html={transformedResNodeHTMLData} />
                                            </div>
                                        }
                                    </div>
                                </Collapse>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </>
            }
        </React.Fragment>
    );
}